import React from 'react';

import type { SsoProvider } from '../../config';

import { GLYPHS } from './glyphs';

export type ProviderIconProps = {
  provider: SsoProvider;
  className?: string;
};

/**
 * Brand glyph for an SSO provider, sized by its parent (1em box). Google + Telegram keep their brand
 * fills (from `glyphs.ts`, a data module so no colour literal lands in this audited `.tsx`).
 */
export const ProviderIcon = ({ provider, className }: ProviderIconProps): React.ReactElement => {
  const glyph = GLYPHS[provider];
  return (
    <svg
      className={className}
      width="1em"
      height="1em"
      viewBox={glyph.viewBox}
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      {glyph.paths.map((path, index) => (
        <path key={index} d={path.d} fill={path.fill} />
      ))}
    </svg>
  );
};

export default ProviderIcon;
